import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewBank = () => {
    const { bankId } = useParams()
    const navigate = useNavigate()
    const [state, setState] = useState({ name: '', description: '' })
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        if (!state.name) newErrors.name = "name is required";
        if (!state.account_number) newErrors.account_number = "account number is required";
        if (!state.balance) newErrors.balance = "account number is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    useEffect(() => {
        if (bankId) {
            axios.get(`/banks/${bankId}`).then((res) => {
                setState({ ...state, name: res.data?.name, account_number: res.data.account_number, balance: res.data.balance })
                console.log(res.data);
            });
        }
    }, [bankId])
    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validateForm()) return;

        const payload = {
            name: state.name,
            account_number: state.account_number,
            balance: state.balance
        }
        const apiUrl = bankId
            ? `/banks/${bankId}`  // Update endpoint
            : '/banks';           // Create endpoint

        const apiCall = bankId
            ? axios.put(apiUrl, payload)                   // Use PUT for update
            : axios.post(apiUrl, payload);                 // Use POST for create

        apiCall
            .then(res => {

                toast.success(res.data?.message || `Banks ${bankId ? 'updated' : 'created'} successfully!`)
                navigate('/banks-list')

            })
            .catch(err => toast.error(err.message || `Error`));
    }
    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <h2 className="text-xl font-bold mb-4">Bank — Add/Update</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-3 gap-4 mb-4">
                    <div>
                        <label className="font-semibold text-sm">Bank Name</label>
                        <input
                            type="text"
                            value={state?.name}
                            placeholder='Enter name'
                            onChange={(e) => {
                                setState({ ...state, name: e.target.value })
                                if (errors.name) setErrors(prev => ({ ...prev, name: null }))
                            }}
                            className={errors.name ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm" htmlFor='account_number'>Account Number</label>
                        <input
                            type="text"
                            id='account_number'
                            value={state?.account_number}
                            placeholder='Enter name'
                            onChange={(e) => {
                                setState({ ...state, account_number: e.target.value })
                                if (errors.account_number) setErrors(prev => ({ ...prev, account_number: null }))
                            }}
                            className={errors.account_number ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.account_number && <p className="text-red-500 text-xs">{errors.account_number}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm" htmlFor='account_number'>Balance</label>
                        <input
                            type="text"
                            id='account_number'
                            value={state?.balance}
                            placeholder='Enter name'
                            disabled={bankId}
                            onChange={(e) => {
                                setState({ ...state, balance: e.target.value })
                                if (errors.balance) setErrors(prev => ({ ...prev, balance: null }))
                            }}
                            className={errors.balance ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.balance && <p className="text-red-500 text-xs">{errors.balance}</p>}
                    </div>
                </div>
                <div className="flex justify-center items-center gap-4 mt-4">
                    <button type='submit' className=" bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded">Save</button>
                    <button type="button" onClick={() => navigate('/banks-list')} className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded">Close</button>
                </div>
            </form>
        </div>
    );
};

export default NewBank;